import * as React from 'react'

import {
  getDirectorJoinUrl,
  getWhitelabelBranding,
} from 'main/components/common/AuthModal/ssoNavigation'
import Loader from 'main/components/common/Loader'
import { useWhitelabel } from 'main/framework'
import useSSOContext from 'main/hooks/useSSOContext'

import { ISSOTrackingProps } from '../../types'
import { BlockContainer } from './DirectorSignUpForm.styles'

export default function DirectorSignUpFormSSO(props: ISSOTrackingProps) {
  const { navContext } = useSSOContext() // this page doesn't set its own nav context but might pass along some
  const whitelabel = useWhitelabel()

  const extraContext = {
    networkId: props?.extraData?.networkId || whitelabel?.networkId,
    ...getWhitelabelBranding(whitelabel),
  }

  const directorJoinUrl = getDirectorJoinUrl(props, navContext, extraContext)

  React.useEffect(() => {
    window.location.replace(directorJoinUrl)
  })

  return (
    <BlockContainer>
      <Loader />
    </BlockContainer>
  )
}
